/** Número con separador de miles colombiano: 3008 → "3.008". */
export const formatNumber = (value) =>
  Number(value ?? 0).toLocaleString("es-CO", { maximumFractionDigits: 2 });
